<template>
  <div class="visitor">
    <div class="release_con">
      <div class="header_content">
        <div class="left" @click="$router.go(-1)">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
        <div class="right">
          放行号：<span>{{ info.releaseNumber }}</span>
        </div>
      </div>
      <div class="visitor_con">
        <div class="content">
          <div class="title">
            <div class="line"></div>
            <div class="titleName">登记信息</div>
          </div>
          <div class="content_list">
            <div class="list_item">
              <div class="name name1">姓名</div>
              <div
                class="value"
                :style="{
                  width: isLandscape ? 60 + '%' : 90 + '%'
                }"
              >
                ：{{ info.driverName }}
              </div>
            </div>
            <div class="list_item">
              <div class="name name1">来访时间</div>
              <div
                class="value"
                :style="{
                  width: isLandscape ? 65 + '%' : 90 + '%'
                }"
              >
                ：{{ info.visitorTime }}
              </div>
            </div>
            <div class="list_item">
              <div class="name name2">自带货物名称</div>
              <div
                class="value"
                :style="{
                  width: isLandscape ? 65 + '%' : 90 + '%'
                }"
              >
                ：{{ info.productName }}
              </div>
            </div>
          </div>
          <div class="content_list">
            <div class="list_item">
              <div class="name name1">电话</div>
              <div
                class="value"
                :style="{
                  width: isLandscape ? 60 + '%' : 90 + '%'
                }"
              >
                ：{{ info.visitorPhone }}
              </div>
            </div>
            <div class="list_item">
              <div class="name name1">车牌号码</div>
              <div
                class="value"
                :style="{
                  width: isLandscape ? 65 + '%' : 90 + '%'
                }"
              >
                ：{{ info.carNumber }}
              </div>
            </div>
            <div class="list_item">
              <div class="name name2">货物数量/重量</div>
              <div
                class="value"
                :style="{
                  width: isLandscape ? 65 + '%' : 90 + '%'
                }"
              >
                ：{{ info.quantityWeight }}
              </div>
            </div>
          </div>
          <div class="content_list">
            <div class="list_item">
              <div class="name name1">单位名称</div>
              <div class="value3 value1">：{{ info.visitorDept }}</div>
            </div>
            <div class="list_item">
              <div class="name name1">车辆类型</div>
              <div class="value3 value1">
                ：{{
                  info.vehicleType == 1
                    ? "货车"
                    : info.vehicleType == 2
                    ? "面包车"
                    : info.vehicleType == 3
                    ? "三轮车"
                    : ""
                }}
              </div>
            </div>
          </div>
          <div class="content_list">
            <div class="list_item">
              <div class="name name1">备注</div>
              <div class="value3 value1">：{{ info.remarkReasons }}</div>
            </div>
          </div>
        </div>
        <div class="content">
          <div class="title">
            <div class="line"></div>
            <div class="titleName">放行信息</div>
          </div>
          <div class="content_list">
            <div class="list_item">
              <div class="name name1">部门</div>
              <div
                class="value"
                :style="{
                  width: isLandscape ? 65 + '%' : 90 + '%'
                }"
              >
                ：{{ info.createrDepartment }}
              </div>
            </div>
            <div class="list_item">
              <div class="name name1">申请人</div>
              <div
                class="value"
                :style="{
                  width: isLandscape ? 65 + '%' : 100 + '%'
                }"
              >
                ：{{ info.createrName }}
              </div>
            </div>
            <div class="list_item" v-if="info.releaseType == 1">
              <div class="name name2">物品类型</div>
              <div
                class="value"
                :style="{
                  width: isLandscape ? 45 + '%' : 90 + '%'
                }"
              >
                ：{{ info.itemType }}
              </div>
            </div>
            <div class="list_item" v-else>
              <div class="name name2">放行人员类型</div>
              <div
                class="value"
                :style="{
                  width: isLandscape ? 45 + '%' : 90 + '%'
                }"
              >
                ：{{ info.personnelType }}
              </div>
            </div>
          </div>
          <div class="content_list">
            <div class="list_item">
              <div class="name name1">放行人员</div>
              <div
                class="value"
                :style="{
                  width: isLandscape ? 65 + '%' : 90 + '%'
                }"
              >
                ：{{ info.driverName }}
              </div>
            </div>
            <div class="list_item" v-if="info.driverCode">
              <div class="name name1">工号</div>
              <div
                class="value"
                :style="{
                  width: isLandscape ? 65 + '%' : 100 + '%'
                }"
              >
                ：{{ info.driverCode }}
              </div>
            </div>
            <div class="list_item" v-if="info.department">
              <div class="name name2">放行人员部门</div>
              <div
                class="value"
                :style="{
                  width: isLandscape ? 45 + '%' : 90 + '%'
                }"
              >
                ：{{ info.department }}
              </div>
            </div>
            <div class="list_item" v-if="!info.department || !info.driverCode">
              <div class="name name1">手机号码</div>
              <div
                class="value"
                :style="{
                  width: isLandscape ? 45 + '%' : 90 + '%'
                }"
              >
                ：{{ info.visitorPhone }}
              </div>
            </div>
            <div class="list_item" v-if="!info.department || !info.driverCode">
              <div class="name name1">预计送回时间</div>
              <div
                class="value3 value1"
                :style="{
                  width: isLandscape ? 60 + '%' : 90 + '%'
                }"
              >
                ：{{ info.arriveDate }}
              </div>
            </div>
          </div>
          <div class="content_list">
            <div class="list_item" v-if="info.driverCode || info.department">
              <div class="name name1">手机号码</div>
              <div
                class="value3 value1"
                :style="{
                  width: isLandscape ? 45 + '%' : 90 + '%'
                }"
              >
                ：{{ info.visitorPhone }}
              </div>
            </div>
            <div class="list_item" v-if="info.driverCode || info.department">
              <div class="name name1">预计送回时间</div>
              <div
                class="value3 value1"
                :style="{
                  width: isLandscape ? 45 + '%' : 90 + '%'
                }"
              >
                ：{{ info.arriveDate }}
              </div>
            </div>
            <div class="list_item">
              <div class="name name4">携带物品是否送回公司</div>
              <div
                class="value"
                :style="{
                  width: isLandscape ? 45 + '%' : 90 + '%'
                }"
              >
                ：{{ info.sendBack == 1 ? "否" : "是" }}
              </div>
            </div>
          </div>
          <div class="content_list">
            <div class="list_item">
              <div class="name name1">放行门卫</div>
              <div
                class="value"
                :style="{
                  width: isLandscape ? 65 + '%' : 90 + '%'
                }"
              >
                ：{{ info.userName }}
              </div>
            </div>
            <div class="list_item">
              <div class="name name1">放行时间</div>
              <div
                class="value"
                :style="{
                  width: isLandscape ? 60 + '%' : 90 + '%'
                }"
              >
                ：{{ info.releaseDate }}
              </div>
            </div>
            <div class="list_item">
              <div class="name name2">放行门卫手机号</div>
              <div
                class="value"
                :style="{
                  width: isLandscape ? 60 + '%' : 90 + '%'
                }"
              >
                ：{{ info.phone }}
              </div>
            </div>
          </div>

          <div class="content_list">
            <div class="list_item">
              <div class="name name1">备注</div>
              <div class="value3 value1">：{{ info.remark }}</div>
            </div>
          </div>
          <div class="content_list">
            <div class="list_item1">
              <div class="name name1">放行物品：</div>
              <div class="table_content">
                <div class="table_header">
                  <div class="left">物品名称</div>
                  <div class="right">数量</div>
                </div>
                <div
                  class="item_content"
                  v-for="(item, index) in info.goods"
                  :key="index"
                >
                  <div class="item_left">{{ item.goodsName }}</div>
                  <div class="item_right">{{ item.goodsNumber }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="content_list">
            <div class="list_item1">
              <div class="name name1">拍照附件：</div>
              <div class="value value1">
                <img
                  :src="item.url"
                  alt=""
                  v-for="(item, index) in info.beforeList"
                  :key="index"
                  style="width: 150px; height: 150px; margin-right: 20px"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/apis";
import apiss from "@/apis/medal";
export default {
  name: "carReleaseDetail",
  data() {
    return {
      info: {},
      isLandscape: false
    };
  },
  watch: {},
  mounted() {
    this.queryDetailsRelease();
    window.addEventListener("orientationchange", this.handleOrientationChange);
    // 初始加载时检测一次方向
    this.handleOrientationChange();
  },
  beforeDestroy() {
    window.removeEventListener(
      "orientationchange",
      this.handleOrientationChange
    );
  },
  methods: {
    // 处理屏幕方向变化
    handleOrientationChange() {
      this.isLandscape =
        window.orientation === 90 || window.orientation === -90;
    },
    // 详情
    queryDetailsRelease() {
      api.queryDetailsRelease({ id: this.$route.query.id }).then(res => {
        if (res.code == 200) {
          this.info = res.data;
          if (res.data.fileIds) {
            const fileIds = res.data.fileIds.split(",");
            this.info.beforeList = fileIds.map(item => {
              return {
                url: apiss.imgUrl + item,
                isImage: true
              };
            });
          } else {
            this.info.beforeList = [];
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.visitor {
  height: calc(100vh - 34px);
  // overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 0px;
    height: 1px;
    background-color: rgba(240, 240, 240, 1);
  }
  .release_con {
    // height: calc(100vh - 54px);
    padding: 8px;
    background-color: #fff;
    border-radius: 8px;
    margin-bottom: 8px;
  }
  .header_content {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    margin-bottom: 5px;
    .left {
      font-size: 13.5px;
      color: #18191e;
      span {
        font-size: 13px;
        margin-left: 10px;
      }
    }
    .right {
      font-size: 11.5px;
      color: #666666;
      span {
        color: #388654;
      }
    }
  }
  .visitor_con {
    height: calc(100vh - 98px);
    overflow-y: auto;
    overflow-x: hidden;
    background-color: #fff;
    &::-webkit-scrollbar {
      width: 0px;
      height: 1px;
      background-color: rgba(240, 240, 240, 1);
    }
  }
  .content {
    padding: 8px 6px 0 6px;
    .title {
      line-height: 11px;
      height: 100%;
      display: flex;
      align-items: center;
      .line {
        width: 2px;
        height: 11px;
        background: #388654;
      }
      .titleName {
        font-weight: bold;
        font-size: 11px;
        color: #18191e;
        margin-left: 5px;
      }
    }
    .content_list {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      margin: 10px 0;
      .list_item {
        width: 170px;
        // width: 31%;
        display: flex;
        // flex-wrap: wrap;
        align-items: flex-start;
        margin-bottom: 10px;
        // margin-right: 10px;
        .name {
          text-align-last: justify;
          text-align: justify;
          font-family: MicrosoftYaHei;
          font-size: 10.5px;
          color: #666666;
          flex-shrink: 0;
        }
        .name1 {
          width: 70px;
        }
        .name2 {
          width: 80px;
        }
        .name3 {
          text-align: right;
          width: 70px;
          font-family: MicrosoftYaHei;
          font-size: 10.5px;
          color: #666666;
          flex-shrink: 0;
        }
        .name4 {
          width: 110px;
        }

        .value {
          // width: 90%;
          flex-shrink: 0;
          color: #282b32;
          font-size: 10.5px;
        }
        .value3 {
          // width: 90%;
          flex-shrink: 0;
          flex-wrap: wrap;
          color: #282b32;
          font-size: 10.5px;
        }
        .value1 {
          width: calc(100vw - 270px);
        }
      }
      .list_item1 {
        .name {
          text-align-last: justify;
          text-align: justify;
          font-family: MicrosoftYaHei;
          font-size: 10.5px;
          color: #666666;
          flex-shrink: 0;
        }
        .name1 {
          width: 60px;
        }
      }
      .table_content {
        background-color: #fff;
        width: 258px;
        margin-top: 10px;
        .table_header {
          height: 26.5px;
          border: 1px solid #dfdfdf;
          background: #f7f9fa;
          font-weight: bold;
          font-size: 10.5px;
          color: #333333;
          display: flex;

          width: 100%;
          .left {
            width: 70%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            border-right: 1px solid #dfdfdf;
          }
          .right {
            width: 30%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
          }
        }
        .item_content {
          height: 26.5px;
          border: 1px solid #dfdfdf;
          border-top: 0;
          display: flex;
          font-size: 9px;
          .item_left {
            width: 70%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-wrap: wrap;
            border-right: 1px solid #dfdfdf;
            padding-left: 10px;
          }
          .item_right {
            width: 30%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
          }
        }
      }
    }
  }
}
</style>
